import { useState } from 'react';
import Layout from '../../../Components/Layout/Layout';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Button } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import Loader from '../../../Components/Spinner/Loader';
import InputField from '../../../Components/Common/InputField';
import { useSendEmailOTP } from '../apiEndpoints/commonApiEndpoints';

const ForgetPassword = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const [email, setEmail] = useState('');
  const { register, handleSubmit } = useForm();
  const { mutate, isPending } = useSendEmailOTP({ type, email });
  const onSubmit: SubmitHandler<any> = async (data: { email: string }) => {
    setEmail(data.email);
    mutate({ ...data, type });
  };
  return (
    <>
      <Layout
        pathName={
          type === 'forget_fair'
            ? 'Exhibitor'
            : type === 'forget_b2b'
            ? 'Buyer/Seller B2B'
            : type === 'forget_visitor'
            ? 'Visitor'
            : ''
        }
        showHeader
      >
        <div className='login-wrapper'>
          <div className='login-div'>
            <div className='login-page'>
              <h3 className='text-center'>Forget password</h3>
              <div className='login-form'>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div>
                    <InputField
                      label='Enter your email'
                      register={register('email')}
                      type='email'
                      isRequired
                      placeholder='Enter your email address'
                    />
                  </div>

                  <div>
                    {isPending ? (
                      <Loader css={'w-100 mt-5 text-white'} />
                    ) : (
                      <Button
                        type='submit'
                        className='w-100 mt-5 submit-button'
                      >
                        Forget password
                      </Button>
                    )}
                  </div>

                  <div className='lost-your-password pt-3 fw-bold text-center'>
                    <Link
                      to={
                        type === 'forget_fair'
                          ? '/login'
                          : type === 'forget_b2b'
                          ? '/b2b-login'
                          : type === 'forget_visitor'
                          ? '/visitor-login'
                          : ''
                      }
                      className='forget-link'
                    >
                      Go back
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ForgetPassword;
